import React from 'react';
import { connect } from 'react-redux';
import { globalFieldLengths } from '@/constants/fields';
import HoverActionHeader from '@/components/HoverActionHeader';
import RequestInput from '../components/RequestInput';
import { resolveRequestWorkflow } from '../state/state';

const RequestName = ({
  code,
  category,
  name,
  isEditing,
  canEdit,
  updateProperties,
}) => (
  <>
    {!isEditing && (<HoverActionHeader className="aridhia-request-list-header" icon="key" value={name} />)}
    {canEdit && isEditing && (
    <RequestInput
      text={name}
      type="name"
      maxLength={globalFieldLengths.name}
      onChange={(value) => updateProperties(category, code, { name: value })}
      icon="table"
      iconPosition="left"
      size="huge"
      autoFocus
    />
    )}
  </>
);

const mapStateToProps = ({
  requests: { requests },
  workflows: { workflows },
}, ownProps) => {
  const { request } = resolveRequestWorkflow(requests, workflows, ownProps, { isEditing: false, name: '' });

  return (
    {
      canEdit: false,
      isEditing: request.isEditing,
      name: request.name,
    }
  );
};

export default connect(mapStateToProps)(RequestName);
